import { Box, Link, Table, Text } from '@chakra-ui/react';

export type DocumentUploadTableRow = {
  id: string;
  createdAt: string;
  filename?: string | null;
};

export function DocumentUploadsTable({
  rows,
  apiHost,
  emptyMessage = 'No files linked to this document yet. Use Upload file… above or paste images into the editor.',
}: {
  rows: DocumentUploadTableRow[];
  apiHost: string;
  /** Shown when `rows` is empty (e.g. editor block vs. files page). */
  emptyMessage?: string;
}) {
  if (rows.length === 0) {
    return (
      <Text color="fg.muted" fontSize="sm">
        {emptyMessage}
      </Text>
    );
  }

  return (
    <Box overflowX="auto">
      <Table.Root
        size="sm"
        variant="line"
        css={{
          '& thead tr, & tbody tr': {
            backgroundColor: 'var(--input-base-background-color)',
          },
        }}
      >
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>Created</Table.ColumnHeader>
            <Table.ColumnHeader>Filename</Table.ColumnHeader>
            <Table.ColumnHeader textAlign="end"> </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows.map((row) => (
            <Table.Row key={row.id}>
              <Table.Cell whiteSpace="nowrap">
                {new Date(row.createdAt).toLocaleString()}
              </Table.Cell>
              <Table.Cell>{row.filename ?? '—'}</Table.Cell>
              <Table.Cell textAlign="end">
                <Link
                  href={`${apiHost}/api/upload/${row.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="blue.600"
                >
                  Open
                </Link>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
}
